import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { apiClient } from "@/api/endpoints";
import { RouteGuards } from "@/features/RouteGuards";
import { SelskapContextProvider } from "@/features/selskap/SelskapContext";
import { ToasterProvider } from "@/features/toaster";

export const Route = createFileRoute("/_app")({
  component: AppLayoutComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        // TODO password : Endre tilbake til "/auth/login" når passordbeskyttelse er fjernet
        to: "/auth/logg-inn",
        throw: true,
      });
    }
  },
});

function AppLayoutComponent() {
  return (
    <SelskapContextProvider>
      <RouteGuards>
        <SetupCSRFToken />
        {/* <div> Sørger for at Toaster havner på rett plass */}
        <div>
          <ToasterProvider />
          <Outlet />
        </div>
      </RouteGuards>
    </SelskapContextProvider>
  );
}

function SetupCSRFToken() {
  useEffect(() => {
    apiClient.auth.setupCsrfToken();
  }, []);

  return null;
}
